var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import "./ImageEditFocalpoint.scss";

var ImageEditFocalpoint = (_temp2 = _class = function (_Component) {
    _inherits(ImageEditFocalpoint, _Component);

    function ImageEditFocalpoint() {
        var _temp, _this, _ret;

        _classCallCheck(this, ImageEditFocalpoint);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            focalpoint: _this.props.focalpoint
        }, _this.getOffset = function (element) {
            var rect = element.getBoundingClientRect();
            var win = element.ownerDocument.defaultView;

            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        }, _this.setFocalpoint = function (event) {
            var imgW = event.target.width;
            var imgH = event.target.height;

            var imgOffset = _this.getOffset(event.target);

            var offsetX = event.pageX - imgOffset.left;
            var offsetY = event.pageY - imgOffset.top;

            var fx = (offsetX / imgW - 0.5) * 2;
            var fy = (offsetY / imgH - 0.5) * -2;

            var parentW = event.target.offsetParent.offsetWidth;
            var parentH = event.target.offsetParent.offsetHeight;
            var parentOffset = _this.getOffset(event.target.offsetParent);

            var parentX = event.pageX - parentOffset.left;
            var parentY = event.pageY - parentOffset.top;

            var reticleX = parentX / parentW * 100;
            var reticleY = parentY / parentH * 100;

            var reticleLeft = reticleX.toFixed(0) + '%';
            var reticleTop = reticleY.toFixed(0) + '%';

            var focalpoint = {
                x: fx,
                y: fy,
                _top: reticleTop,
                _left: reticleLeft
            };

            _this.setState({
                focalpoint: focalpoint
            });

            if (_this.props.onFocalpoint) {
                _this.props.onFocalpoint(focalpoint);
            }
        }, _this.getReticleStyle = function () {
            var _this$props$focalpoin = _this.props.focalpoint,
                _top = _this$props$focalpoin._top,
                _left = _this$props$focalpoin._left;


            var style = {
                top: _top,
                left: _left
            };

            return style;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ImageEditFocalpoint.prototype.render = function render() {
        var focalpoint = this.state.focalpoint;
        var media = this.props.media;
        var imageUrl = media.imageUrl;


        var reticleStyle = {
            top: focalpoint._top,
            left: focalpoint._left
        };

        return React.createElement(
            'div',
            { className: 'edit__focalpoint' },
            React.createElement('div', { className: 'focalpoint__background' }),
            React.createElement('img', { src: imageUrl, onClick: this.setFocalpoint, ref: 'image' }),
            React.createElement('div', { className: 'focalpoint__reticle', style: reticleStyle })
        );
    };

    return ImageEditFocalpoint;
}(Component), _class.defaultProps = {
    focalpoint: {
        x: 0, y: 0,
        _top: '50%', _left: '50%'
    }
}, _temp2);


export default ImageEditFocalpoint;